import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';

interface LegalTextProps {
  children?: React.ReactNode;
  isSEAPage?: boolean;
}

const LegalText: React.FC<LegalTextProps> = ({ children, isSEAPage }) => {
  const theme = useTheme();
  const fontColor = isSEAPage
    ? theme.palette.text.tertiary
    : theme.palette.secondary[700];

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          py: 3,
        }}
      >
        <div
          style={{ fontSize: '0.75rem', lineHeight: '1.9', color: fontColor }}
        >
          {isSEAPage && (
            <div>
              <b>Sparen Sie über 35% mit smava: </b>
              <>
                Vgl. der eff. Jahreszinssätze neuer (lt. Bundesbank) mit den
                über smava vermittelten Krediten 2020.{' '}
                <a href="https://www.smava.de/kreditvergleich/">Mehr Infos</a>.
              </>
            </div>
          )}
          <div style={{ color: fontColor }}>{children}</div>
        </div>
      </Box>
    </Container>
  );
};
export default LegalText;
